import React from "react";
import { createPortal } from "react-dom";
import { ActionBarHooks, useEditPrimaryCampaignAction, useEditActivationCampaignAction } from "./actions";

export default ({ renderContainer }) =>
	Object.entries(ActionBarHooks).map(([actionName, UseAction]) => {
		let Trigger;
		let DisplayedComponent;

		if (actionName === "EditCampaign") {
			const PrimaryCampaignAction = useEditPrimaryCampaignAction();
			const ActivationCampaignAction = useEditActivationCampaignAction();

			Trigger = function Trigger() {
				return (
					<UseAction>
						<PrimaryCampaignAction.Trigger />
						<ActivationCampaignAction.Trigger />
					</UseAction>
				);
			};

			DisplayedComponent = [PrimaryCampaignAction.DisplayedComponent, ActivationCampaignAction.DisplayedComponent];
		} else {
			({ Trigger, DisplayedComponent } = UseAction?.() || {});
			// put DC in an array so it can be destructured properly below
			DisplayedComponent &&= [DisplayedComponent];
		}

		// return a children array containing the Trigger, and the portalized displayed Component(s)
		return [<Trigger key={1} />, ...(DisplayedComponent?.map?.((DC, i) => createPortal(<DC key={i + 1} />, renderContainer)) || [])];
	});
